import { useEffect, useRef, useState } from "react";
import IconAdd from "../../components/icons/IconAdd";

export default function AddQuestionButton({ onCreate }) {
    const [isOpen, setIsOpen] = useState(false);
    const [text, setText] = useState("");
    const textareaRef = useRef(null);

    const toggleOpen = () => setIsOpen((prev) => !prev);

    useEffect(() => {
        if (isOpen) textareaRef.current?.focus();
    }, [isOpen]);

    const handleSave = () => {
        if (!text.trim()) return;
        onCreate(text)
            .then(() => {
                setText("");
                setIsOpen(false);
            })
            .catch((err) => console.error(err));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSave();
        }
        if (e.key === "Escape") {
            setIsOpen(false);
        }
    };

    return (
        <div
            className="functional-panelbutton"
            onMouseDown={(e) => {
                e.stopPropagation();
                toggleOpen();
            }}
        >
            <IconAdd />
            {isOpen ? (
                <div className="canvas-question-form" onMouseDown={(e) => e.stopPropagation()}>
                    <p>Додати нове питання</p>
                    <textarea
                        ref={textareaRef}
                        name="text"
                        className="txt-c"
                        placeholder="text..."
                        id="question-form"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                    <button onClick={handleSave} className=" form-button txt-c" style={{ marginInline: "auto" }}>
                        Save
                    </button>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
